export default __webpack_public_path__ + "static/Cover-1ab4774d23db320bd58c5c0fae48bda4.png";